var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":_vm.toolbarColor,"dark":"","dense":"","elevation":"0"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-calendar-check")]),_c('v-toolbar-title',[_vm._v("System Configuration - Year of Study")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }